// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TravelCreditCardRouteImport } from './routes/travel-credit-card'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IxiFinanceIndexRouteImport } from './routes/ixi-finance.index'
import { Route as TravelCreditCardManageRouteImport } from './routes/travel-credit-card_.manage'
import { Route as TravelCreditCardComparisonRouteImport } from './routes/travel-credit-card_.comparison'
import { Route as TravelCreditCardApplyRouteImport } from './routes/travel-credit-card_.apply'
import { Route as IxiFinanceTransactionHistoryRouteImport } from './routes/ixi-finance.transaction-history'
import { Route as IxiFinanceCreatorsRouteImport } from './routes/ixi-finance.creators'
import { Route as IxiFinancePartnerLinkRouteImport } from './routes/ixi-finance.partner.link'
import { Route as IxiFinanceCreatorsTermsRouteImport } from './routes/ixi-finance.creators_.terms'
import { Route as IxiFinanceCreatorsPrivacyRouteImport } from './routes/ixi-finance.creators_.privacy'
import { Route as AuthIxiFinanceManagePaymentsRouteImport } from './routes/_auth.ixi-finance.manage-payments'
import { Route as AuthIxiFinanceGiftCardsRouteImport } from './routes/_auth.ixi-finance.gift-cards'
import { Route as AuthIxiFinanceGiftCardsAddRouteImport } from './routes/_auth.ixi-finance.gift-cards_.add'
import { Route as AuthIxiFinanceCreatorsOnboardingRouteImport } from './routes/_auth.ixi-finance.creators_.onboarding'
import { Route as AuthIxiFinanceCreatorsDashboardRouteImport } from './routes/_auth.ixi-finance.creators_.dashboard'
import { Route as AuthIxiFinanceCreatorsDashboardIndexRouteImport } from './routes/_auth.ixi-finance.creators_.dashboard.index'
import { Route as AuthIxiFinanceCreatorsDashboardSocialRouteImport } from './routes/_auth.ixi-finance.creators_.dashboard.social'
import { Route as AuthIxiFinanceCreatorsDashboardPayoutRouteImport } from './routes/_auth.ixi-finance.creators_.dashboard.payout'
import { Route as AuthIxiFinanceCreatorsDashboardItineraryRouteImport } from './routes/_auth.ixi-finance.creators_.dashboard.itinerary'
import { Route as AuthIxiFinanceCreatorsDashboardAnalyticsRouteImport } from './routes/_auth.ixi-finance.creators_.dashboard.analytics'

const TravelCreditCardRoute = TravelCreditCardRouteImport.update({
            id: '/travel-credit-card',path: '/travel-credit-card',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const IxiFinanceIndexRoute = IxiFinanceIndexRouteImport.update({
            id: '/ixi-finance/',path: '/ixi-finance/',getParentRoute: () => rootRouteImport
          })
const TravelCreditCardManageRoute = TravelCreditCardManageRouteImport.update({
            id: '/travel-credit-card_/manage',path: '/travel-credit-card/manage',getParentRoute: () => rootRouteImport
          })
const TravelCreditCardComparisonRoute = TravelCreditCardComparisonRouteImport.update({
            id: '/travel-credit-card_/comparison',path: '/travel-credit-card/comparison',getParentRoute: () => rootRouteImport
          })
const TravelCreditCardApplyRoute = TravelCreditCardApplyRouteImport.update({
            id: '/travel-credit-card_/apply',path: '/travel-credit-card/apply',getParentRoute: () => rootRouteImport
          })
const IxiFinanceTransactionHistoryRoute = IxiFinanceTransactionHistoryRouteImport.update({
            id: '/ixi-finance/transaction-history',path: '/ixi-finance/transaction-history',getParentRoute: () => rootRouteImport
          })
const IxiFinanceCreatorsRoute = IxiFinanceCreatorsRouteImport.update({
            id: '/ixi-finance/creators',path: '/ixi-finance/creators',getParentRoute: () => rootRouteImport
          })
const IxiFinancePartnerLinkRoute = IxiFinancePartnerLinkRouteImport.update({
            id: '/ixi-finance/partner/link',path: '/ixi-finance/partner/link',getParentRoute: () => rootRouteImport
          })
const IxiFinanceCreatorsTermsRoute = IxiFinanceCreatorsTermsRouteImport.update({
            id: '/ixi-finance/creators_/terms',path: '/ixi-finance/creators/terms',getParentRoute: () => rootRouteImport
          })
const IxiFinanceCreatorsPrivacyRoute = IxiFinanceCreatorsPrivacyRouteImport.update({
            id: '/ixi-finance/creators_/privacy',path: '/ixi-finance/creators/privacy',getParentRoute: () => rootRouteImport
          })
const AuthIxiFinanceManagePaymentsRoute = AuthIxiFinanceManagePaymentsRouteImport.update({
            id: '/ixi-finance/manage-payments',path: '/ixi-finance/manage-payments',getParentRoute: () => AuthRoute
          })
const AuthIxiFinanceGiftCardsRoute = AuthIxiFinanceGiftCardsRouteImport.update({
            id: '/ixi-finance/gift-cards',path: '/ixi-finance/gift-cards',getParentRoute: () => AuthRoute
          })
const AuthIxiFinanceGiftCardsAddRoute = AuthIxiFinanceGiftCardsAddRouteImport.update({
            id: '/ixi-finance/gift-cards_/add',path: '/ixi-finance/gift-cards/add',getParentRoute: () => AuthRoute
          })
const AuthIxiFinanceCreatorsOnboardingRoute = AuthIxiFinanceCreatorsOnboardingRouteImport.update({
            id: '/ixi-finance/creators_/onboarding',path: '/ixi-finance/creators/onboarding',getParentRoute: () => AuthRoute
          })
const AuthIxiFinanceCreatorsDashboardRoute = AuthIxiFinanceCreatorsDashboardRouteImport.update({
            id: '/ixi-finance/creators_/dashboard',path: '/ixi-finance/creators/dashboard',getParentRoute: () => AuthRoute
          })
const AuthIxiFinanceCreatorsDashboardIndexRoute = AuthIxiFinanceCreatorsDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthIxiFinanceCreatorsDashboardRoute
          })
const AuthIxiFinanceCreatorsDashboardSocialRoute = AuthIxiFinanceCreatorsDashboardSocialRouteImport.update({
            id: '/social',path: '/social',getParentRoute: () => AuthIxiFinanceCreatorsDashboardRoute
          })
const AuthIxiFinanceCreatorsDashboardPayoutRoute = AuthIxiFinanceCreatorsDashboardPayoutRouteImport.update({
            id: '/payout',path: '/payout',getParentRoute: () => AuthIxiFinanceCreatorsDashboardRoute
          })
const AuthIxiFinanceCreatorsDashboardItineraryRoute = AuthIxiFinanceCreatorsDashboardItineraryRouteImport.update({
            id: '/itinerary',path: '/itinerary',getParentRoute: () => AuthIxiFinanceCreatorsDashboardRoute
          })
const AuthIxiFinanceCreatorsDashboardAnalyticsRoute = AuthIxiFinanceCreatorsDashboardAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthIxiFinanceCreatorsDashboardRoute
          })





const AuthIxiFinanceCreatorsDashboardRouteChildren = {
  AuthIxiFinanceCreatorsDashboardAnalyticsRoute: AuthIxiFinanceCreatorsDashboardAnalyticsRoute,AuthIxiFinanceCreatorsDashboardItineraryRoute: AuthIxiFinanceCreatorsDashboardItineraryRoute,AuthIxiFinanceCreatorsDashboardPayoutRoute: AuthIxiFinanceCreatorsDashboardPayoutRoute,AuthIxiFinanceCreatorsDashboardSocialRoute: AuthIxiFinanceCreatorsDashboardSocialRoute,AuthIxiFinanceCreatorsDashboardIndexRoute: AuthIxiFinanceCreatorsDashboardIndexRoute
}

const AuthIxiFinanceCreatorsDashboardRouteWithChildren = AuthIxiFinanceCreatorsDashboardRoute._addFileChildren(AuthIxiFinanceCreatorsDashboardRouteChildren)



const AuthRouteChildren = {
  AuthIxiFinanceGiftCardsRoute: AuthIxiFinanceGiftCardsRoute,AuthIxiFinanceManagePaymentsRoute: AuthIxiFinanceManagePaymentsRoute,AuthIxiFinanceCreatorsDashboardRoute: AuthIxiFinanceCreatorsDashboardRouteWithChildren,AuthIxiFinanceCreatorsOnboardingRoute: AuthIxiFinanceCreatorsOnboardingRoute,AuthIxiFinanceGiftCardsAddRoute: AuthIxiFinanceGiftCardsAddRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRouteWithChildren,TravelCreditCardRoute: TravelCreditCardRoute,IxiFinanceCreatorsRoute: IxiFinanceCreatorsRoute,IxiFinanceTransactionHistoryRoute: IxiFinanceTransactionHistoryRoute,TravelCreditCardApplyRoute: TravelCreditCardApplyRoute,TravelCreditCardComparisonRoute: TravelCreditCardComparisonRoute,TravelCreditCardManageRoute: TravelCreditCardManageRoute,IxiFinanceIndexRoute: IxiFinanceIndexRoute,IxiFinanceCreatorsPrivacyRoute: IxiFinanceCreatorsPrivacyRoute,IxiFinanceCreatorsTermsRoute: IxiFinanceCreatorsTermsRoute,IxiFinancePartnerLinkRoute: IxiFinancePartnerLinkRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)